import React, { Component } from "react";
import Link from "next/link";
import { fetchAllBlog } from "../../src/store/actions";
import { NotFound } from "../../src/components/common/NotFound";
import { connect } from "react-redux";
import { Pagination } from "antd";

class GovernmentJobs extends Component {
  static async getInitialProps(ctx) {
    try {
      const gvJobs = await ctx.store.dispatch(
        fetchAllBlog({ type: "government-jobs", limit: 12 })
      );
      return {
        title: gvJobs.data.category.meta_title || gvJobs.data.category.name,
        meta_desc: gvJobs.data.category.meta_desc,
        keywords: gvJobs.data.category.meta_key,
        image: gvJobs.data.category.image,
        showFooter: true,
      };
    } catch (e) {
      console.log(e.response);
    }
  }
  render() {
    const {
      blog: { data, pagination },
    } = this.props;
    return (
      <div>
        <div className="tr-breadcrumb bg-image section-before jobs-listing">
          <div className="container">
            <div className="breadcrumb-info text-center">
              <h2>{"Government Jobs".toUpperCase()}</h2>

              <ul className="job-meta tr-list list-inline">
                <li>
                  <Link href={"/"}>
                    <a href={""}>
                      <i className="fas fa-home" />
                      {"Rojgari Sanjal"}
                    </a>
                  </Link>
                  &nbsp;&nbsp;
                  <i className="fas fa-chevron-right" />
                  <span style={{ color: "#ccc" }}>Government Jobs</span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="job-list-container">
          <div className="container-fluid">
            <div className="blog_grid_box_container">
              <div className="row">
                {data.length < 1 ? <NotFound /> : null}
                {data.map((item, key) => {
                  return (
                    <div className="col-lg-3 col-md-6" key={key}>
                      <div className="blog_grid_box">
                        <figure>
                          <img
                            src={`${item.image}`}
                            onError={(e) => {
                              e.target.src =
                                "https://www.worldloppet.com/wp-content/uploads/2018/10/no-img-placeholder.png";
                            }}
                            className="img-fluid"
                            alt="Responsive image"
                          />
                        </figure>
                        <div className="blog_grid_content">
                          <h1>{item.title} </h1>
                          {/* <p>2020-09-26 23:00:15 By <strong>admin </strong></p> */}
                          <p>
                            {item.short_desc.substr(0, 90)}{" "}
                            {item.short_desc.length > 90 ? "..." : ""}
                          </p>

                          <Link
                            href={`/government-jobs/details/${item.slug}-${item.id}`}
                            as={`/government-jobs/details/${item.slug}-${item.id}`}
                          >
                            <a
                              href={`/government-jobs/details/${item.slug}-${item.id}`}
                              className="btn btn-success btn-block view_more"
                            >
                              View Details
                            </a>
                          </Link>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
            <div className="row">
              <div className={"col-12"}>
                {pagination && pagination.totalCount > 12 ? (
                  <Pagination
                    pageSize={12}
                    current={pagination.page}
                    defaultCurrent={1}
                    total={pagination.totalCount}
                    onChange={(page, limit) => {
                      this.props.fetchAllBlog({
                        page,
                        type: "government-jobs",
                        limit: 12,
                      });
                    }}
                  />
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    app: state.app,
    blog: state.blog,
  };
};

export default connect(mapStateToProps, { fetchAllBlog })(GovernmentJobs);
